import GameIds from '../../hub/data/GameIds';

export const GAME_ID = GameIds.PUNCHLINE;
export const NUM_LEVELS = 11;
export const QUESTIONS_PER_ROUND = 6;
export const DEFINITIONS_PER_BONUS_ROUND = 3;
export const ANSWERS_COUNT_TO_MASTER_LEVEL = 5;
export const JOKES_PER_LEVEL = 3;

export const SCREENS = {
  STANDARD: 'standard',
  PROGRESS: 'progress',
  LOADING: 'loading',
};

export const GAME_PHASES = {
  SELECT_PUNCHLINE: 'selectPunchline',
  SELECT_WORD: 'selectWord',
  VIEW_DEFINITIONS: 'viewDefinitions',
  SELECT_DEFINITIONS: 'selectDefinitions',
};

export const ONBOARDING_PHASES = {
  NONE: 'none',
  LEFT_ONLY: 'leftOnly',
  BOTH: 'both',
  COMPLETE: 'complete',
};

export const PUNCHLINE_BOX_DISPLAY_STATES = {
  DEFAULT: 'punchlineDefault',
  CORRECT: 'punchlineCorrect',
  INCORRECT: 'punchlineIncorrect',
  FADED: 'punchlineFaded',
};

export const DEFINITION_BOX_DISPLAY_STATES = {
  DEFAULT: 'definitionDefault',
  CORRECT: 'definitionCorrect',
  INCORRECT: 'definitionIncorrect',
};

export const PUNCHLINE_CLICK_FEEDBACK_STATES = {
  NONE: 'none',
  CORRECT: 'correct',
  INCORRECT: 'incorrect',
};

export const ACTION_SEQUENCES = {
  ONBOARD_FULL: 'onboardFull',
  ONBOARD_SHORT: 'onboardShort',
  ALEX: 'alex',
  PUNCHLINE_CORRECT: 'punchlineCorrect',
  PUNCHLINE_INCORRECT: 'punchlineIncorrect',
  WORD_CORRECT: 'wordCorrect',
  WORD_INCORRECT: 'wordIncorrect',
  DEFINITION_EXPLANATION: 'definitionExplanation',
  SELECT_DEFINITION_INTRO: 'selectDefinitionIntro',
  SECOND_CORRECT_DEFINITION: 'secondCorrectDefinition',
  PLAY_POSITIVE_SOUND: 'playPositiveSound',
  PLAY_NEGATIVE_SOUND: 'playNegativeSound',
};

// searchlight actions
export const SEARCHLIGHT_DISPATCH_EVENT = 'SEARCHLIGHT_DISPATCH_EVENT';

// user-initiated actions
export const SELECT_PUNCHLINE = 'SELECT_PUNCHLINE';
export const SELECT_WORD = 'SELECT_WORD';
export const SELECT_DEFINITION = 'SELECT_DEFINITION';
export const SELECT_BACK = 'SELECT_BACK';
export const SELECT_LEVEL = 'SELECT_LEVEL';
export const SELECT_NEXT = 'SELECT_NEXT';
export const FINISH_ROUND = 'FINISH_ROUND';
export const TOGGLE_PARTICLES = 'TOGGLE_PARTICLES';
export const SET_SCREEN = 'SET_SCREEN';
export const FLIP_CONTENT_SIDE = 'FLIP_CONTENT_SIDE';

// task-initiated actions
export const INIT_ACTION_SEQUENCE = 'INIT_ACTION_SEQUENCE';
export const INIT_ONBOARDING = 'INIT_ONBOARDING';
export const SET_ALEX_STATE = 'SET_ALEX_STATE';
export const SET_ONBOARDING_PHASE = 'SET_ONBOARDING_PHASE';
export const SET_GAME_PHASE = 'SET_GAME_PHASE';
export const UNLOCK_INTERACTION = 'UNLOCK_INTERACTION';
export const INCREMENT_PROGRESS_BAR = 'INCREMENT_PROGRESS_BAR';
export const ACTIVATE_NEXT_BUTTON = 'ACTIVATE_NEXT_BUTTON';
export const SET_HIGHLIGHTED_WORD = 'SET_HIGHLIGHTED_WORD';
export const HIGHLIGHT_DEFINITIONS = 'HIGHLIGHT_DEFINITIONS';
export const FINISH_SELECT_DEFINITION = 'FINISH_SELECT_DEFINITION';
export const ADD_TO_CORRECT_COUNT = 'ADD_TO_CORRECT_COUNT';
export const INITIALIZE_JOKES = 'INITIALIZE_JOKES';
export const START_BONUS_GAME = 'START_BONUS_GAME';

export const PROGRESS_INCREMENT = (1 / QUESTIONS_PER_ROUND) * 100;

export const BONUS_GAME_BACKGROUND_COLORS = ['#36C1A4', '#24B6D1'];
export const JOKE_BACKGROUND_COLORS = [
  ['#3898F4', '#4155E0'],
  ['#774D87', '#AA2E7F'],
  ['#684D87', '#8634A4'],
];
